export default "__VITE_ASSET__d15e3533__"